import { IDialogProps } from "./interfaces";

export const defaultProps: IDialogProps = {
    dialogContentProps: {},
    modalProps: {
        className: ''
    }
};